import React from "react";
import { Redirect } from "react-router";
import { useEffect } from "react";
import axios from '../../axios/axiosconf';

function Logout() {
    
    useEffect(()=>{

        let userdata = [];    

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        //axios.get('/logout', config)
        axios.get('/logout')
            .then((response) => {
                if (response.status===200) {
                    localStorage.clear();
                }
            })
            .catch((error) => {
                console.log(error);
            })    
    },[]);

    return <Redirect to="/" />
}
export default Logout;